import { RequestStatus } from '../enums';

const initialState = {
  items: [],
  status: RequestStatus.IDLE,
  error: null,
};

export default initialState;
